import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';
import { EpxConfirmDialogComponent } from '@shared/components/messages/epx-confirm-dialog/epx-confirm-dialog.component';
import { EpxErrorDialogComponent } from '@shared/components/messages/epx-error-dialog/epx-error-dialog.component';
import { EpxConfirmPopupComponent } from '@shared/components/messages/epx-confirm-popup/epx-confirm-popup.component';

@Component({
    selector: 'epx-messages',
    template: `
        <p-toast #toast [autoZIndex]="false" key="epx-toast" [style]="{ zIndex: '9999999' }" [showTransitionOptions]="'250ms'" [hideTransitionOptions]="'250ms'">
            <ng-template let-message pTemplate="message">
                <section class="epx-toast-message">
                    <section class="epx-toast-icon">
                        <i [class]="message.icon"></i>
                    </section>
                    <section class="epx-toast-content">
                        @if (message.summary) {
                            <div class="pdx-toast-summary">
                                {{ message.summary | translate }}
                            </div>
                        }
                        <div class="epx-toast-details">
                            <span [innerHTML]="message.detail | translate"></span>
                        </div>
                    </section>
                </section>
            </ng-template>
        </p-toast>
        <epx-confirm-dialog></epx-confirm-dialog>
        <epx-error-dialog></epx-error-dialog>
        <epx-confirm-popup></epx-confirm-popup>
    `,
    imports: [CommonModule, ToastModule, TranslatePipe, EpxConfirmDialogComponent, EpxErrorDialogComponent, EpxConfirmPopupComponent]
})
export class MessagesComponent {}
